"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pinia_1 = require("pinia");
var pinia_plugin_persistedstate_1 = __importDefault(require("pinia-plugin-persistedstate"));
// 创建 pinia 实例
var pinia = (0, pinia_1.createPinia)();
// 使用持久化存储插件
pinia.use(pinia_plugin_persistedstate_1.default);
// 默认导出，给 main.ts 使用
exports.default = pinia;
// 模块统一导出
__exportStar(require("./modules/member"), exports);
